import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TawkToWidget = () => {
  const location = useLocation();

  // Define routes where you DON'T want the widget
  const excludedRoutes = ["/show-meeting"];

  useEffect(() => {
    // Check if the current route is excluded
    const shouldShowWidget = !excludedRoutes.some(route => location.pathname.startsWith(route));

    if (true) {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://embed.tawk.to/6784a0d249e2fd8dfe068169/1ihf18dnj";
      script.charset = "UTF-8";
      script.setAttribute("crossorigin", "*");
      document.body.appendChild(script);

      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_API.onLoad = function () {
        // const tawkIframe = document.querySelector('iframe[title="chat widget"]');
        // if (tawkIframe) {
        //   tawkIframe.style.bottom = "120px"; // ✅ This overrides inline style directly
        // }

        const iframes = document.querySelectorAll('iframe[title="chat widget"]');
        console.log("ifrmease", iframes);
        iframes.forEach((iframe) => {
          console.log("ifrmeae", iframe);
          // iframe.style.bottom = "60px";
          iframe.style.setProperty('bottom', '90px', 'important'); // 🔥 This applies with !important
        });

      };

      return () => {
        if (window.Tawk_API && window.Tawk_API.hide) {
          window.Tawk_API.hide();  // Hide widget on unmount
        }
        document.body.removeChild(script);
      };
    } else {
      // Hide widget if route is excluded
      if (window.Tawk_API && window.Tawk_API.hide) {
        window.Tawk_API.hide();
      }
    }
  }, [location.pathname]); // Re-run when route changes

  return null; // No UI needed for this component
};

export default TawkToWidget;
